
import { ChangeDetectionStrategy, Component, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { BannerComponent } from 'libs/shared/ui-common/src/lib/components/banner/banner.component';
import { CheckboxComponent } from 'shared/ui-common';

export type ShareUpdateMode = 'manual' | 'automatic' | undefined;

@Component({
  standalone: true,
  imports: [CheckboxComponent, TranslocoPipe, FormsModule, BannerComponent],
  selector: 'tt-shared-guideline-import-update-settings',
  templateUrl: './guideline-import-update-settings.component.html',
  styleUrls: ['./guideline-import-update-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuidelineImportUpdateSettingsComponent {
  public updateMode = model<ShareUpdateMode | undefined>(undefined);
  public forwardEmailNotifications = model<boolean>();

  protected toggleManualUpdateMode() {
    this.updateMode.update((updateMode) => (updateMode === 'manual' ? undefined : 'manual'));
  }

  protected toggleAutomaticUpdateMode() {
    this.updateMode.update((updateMode) => (updateMode === 'automatic' ? undefined : 'automatic'));
  }

  protected toggleEmailNotification() {
    this.forwardEmailNotifications.update((value) => !value);
  }
}
